<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>Percobaan</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">

            <select v-model="option" @change="movePage">
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
            </select>

            <div class="box-custom" id="1">1</div>
            <div class="box-custom" id="2">2</div>
            <div class="box-custom" id="3">3</div>
            <div class="box-custom" id="4">4</div>
            <div class="box-custom" id="5">5</div>

            <!-- scroll button bottom -->
            <div class="scroll-to-top-up" id="scroll-to-top-up">
              <div class="scrollup">
                <i class="fa fa-arrow-circle-up fa-5x text-success"></i>
              </div>
            </div>
            <div class="scroll-to-top-down" id="scroll-to-top-down">
              <div class="scrollup">
                <i class="fa fa-arrow-circle-down fa-5x text-success"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';

const nama = ref('antonius');
const data = reactive({});

// show hide button scroll up and down
window.onscroll = function () {
  const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

  if (winScroll >= height - 50) {
    document.getElementById("scroll-to-top-up").style.display = "block";
    document.getElementById("scroll-to-top-down").style.display = "none";
  } else if (winScroll > 50 && winScroll < height - 50) {
    document.getElementById("scroll-to-top-up").style.display = "block";
    document.getElementById("scroll-to-top-down").style.display = "block";
  } else if (winScroll <= 50) {
    document.getElementById("scroll-to-top-up").style.display = "none";
    document.getElementById("scroll-to-top-down").style.display = "block";
  }
}


// const option = ref(null);
// const movePage = () => {
//   console.log(option.value);
//   // scroll window to id
//   window.scrollTo({
//     top: document.getElementById(option.value).offsetTop,
//     behavior: 'smooth'
//   });
// };

// // hide element when page scroll
// window.onscroll = function () {
//   var scroll = document.documentElement.scrollTop || document.body.scrollTop;
//   var box = document.getElementById('1');
//   if (scroll > 0) {
//     box.style.display = 'none';
//   } else {
//     box.style.display = 'block';
//   }
// };

// remove class by classname
// const removeClass = (className) => {
//   const elements = document.getElementsByClassName(className);
//   for (let i = 0; i < elements.length; i++) {
//     elements[i].classList.remove(className);
//   }
// };

// const element = document.getElementById('#' + option.value);
// element.scrollIntoView({ behavior: 'smooth' });

// const listName = ref([
//   {
//     text: "Tri Aryani 2020070119",
//     value: "2020070119"
//   },
//   {
//     text: "Xoxo Susiyati 2020030128",
//     value: "2020030128"
//   },
//   {
//     text: "Sri Susiyati 2020030128",
//     value: "2020030128"
//   },
//   {
//     text: "Muh Susiyati 2020030128",
//     value: "2020030128"
//   }
// ]);

// // sort listName by text
// listName.value.sort((a, b) => {
//   if (a.text < b.text) {
//     return -1;
//   }
//   if (a.text > b.text) {
//     return 1;
//   }
//   return 0;
// });

// console.log(listName.value);

</script>

<style scoped>
.box-custom {
  width: 500px;
  height: 500px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  margin: 10px;
}

/* scroll-to-top */
.scroll-to-top-up {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 9999;
}

.scroll-to-top-down {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
}
</style>
